import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutPersonOrgRoleData = (personId, personOrgRoleId, orgRoleObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const personOrgRoleIdForUrl = personOrgRoleId ? encodeURIComponent(personOrgRoleId) : 'NaN';

    const url = `/Person/${personIdForUrl}/orgRole/${personOrgRoleIdForUrl}`;
    PersonHttpHelper(url, 'PUT', orgRoleObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutPersonOrgRoleData;